var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.955 8.955 0 20 0C31.045 0 40 8.955 40 20C40 31.045 31.045 40 20 40C8.955 40 0 31.045 0 20ZM18.5783 28.7783L31.1783 16.1783C31.83 15.5267 31.83 14.4733 31.1783 13.8217C30.5267 13.17 29.4733 13.17 28.8217 13.8217L17.4 25.2433L12.8233 20.6667C12.1717 20.015 11.1183 20.015 10.4667 20.6667C9.815 21.3183 9.815 22.3717 10.4667 23.0233L16.2217 28.7783C16.5333 29.0917 16.9583 29.2667 17.4 29.2667C17.8417 29.2667 18.265 29.0917 18.5783 28.7783Z",
    fill: "#73B709"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.20dea9bda45ce85ab6466e0308c06291.svg";
export { ForwardRef as ReactComponent };